import { TAG } from '../../tag/TAG';
import { ValueConcept } from '../types/ValueConcept';

export interface ListValueConceptsResponse {
  readonly value_concepts: ReadonlyArray<ValueConcept>;
  readonly next_page_token: string;
  readonly page_size: number;
}

export const ListValueConcepts = (fieldConceptKey: string, token?: string, pageSize?: number): Promise<ListValueConceptsResponse> => {
  return TAG.Get<ListValueConceptsResponse>(`semantic-model/data-roles/${fieldConceptKey}/value-concepts`, {next_page_token: token, page_size: pageSize});
};
